export function InfoIcon() {
  return (
    <svg viewBox="0 0 12 12" className="size-3" fill="none" aria-hidden>
      <rect x="0.5" y="0.5" width="11" height="11" stroke="currentColor" />
      <path d="M6 3.1v1.1M6 5.5v3.3" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}
